module.exports = __webpack_public_path__ + "img/GAME_POND2.18add637.jpg";